/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GuardianModel } from '../../models/guardian-model';

export interface GetPatientGuardians$Params {
  patientID?: number;
}

export function GetPatientGuardians(http: HttpClient, rootUrl: string, params?: GetPatientGuardians$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GuardianModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientGuardians.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GuardianModel>>;
    })
  );
}

GetPatientGuardians.PATH = '/api/Staff/GetPatientGuardians';
